import PropTypes from 'prop-types'
import React, { useContext } from 'react'
import { ThemeContext } from 'styled-components'

import HowToBlock from 'components/_special/HowToBlock'
import { RU, IE, BE, NL } from 'constants/countries'
import { LocalizationContext } from 'contexts/Localization'
import useCoverForProductReturn from 'hooks/media/useCoverForProductReturn'
import { Text } from 'styles/components/typography'

import { SectionWrapperStyled } from './styles'

/**
 * BHowReturn
 *
 * @param {object} props - properties of component
 * @returns {node} BHowReturn
 */
const BHowReturn = ({ data, index, isSquareHidden }) => {
  const { colors } = React.useContext(ThemeContext)
  const {
    locale,
    paths: { cdn_global, cdn },
  } = useContext(LocalizationContext)
  const isRu = locale === RU
  const isEU = [IE, BE, NL].includes(locale)
  const isPng = isRu || isEU
  const squareColor = isPng ? colors.materialRed : colors.orange
  const coverUrl = useCoverForProductReturn({ locale, cdn, cdn_global })

  const classNameInner = isPng ? 'inner--png' : 'pb-4'

  return (
    <SectionWrapperStyled
      withOverlay={!isPng}
      classNameInner={`inner ${classNameInner}`}
      isPng={isPng}
      coverUrl={coverUrl}
    >
      <HowToBlock
        isSquareHidden={isSquareHidden}
        title={isEU ? data[locale].title : data.title}
        index={index}
        squareColor={squareColor}
        lineColor="light"
        textColor="light"
      >
        <div className="row">
          <div className="col-12 col-md-6 col-lg-5 offset-md-1">
            <Text
              className="with-inverted-links"
              dangerouslySetInnerHTML={{
                __html: isEU ? data[locale].content : data.content,
              }}
            />
          </div>
        </div>
      </HowToBlock>
    </SectionWrapperStyled>
  )
}

BHowReturn.propTypes = {
  data: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  isSquareHidden: PropTypes.bool,
}

BHowReturn.defaultProps = {
  isSquareHidden: false,
}

export default BHowReturn
